import qs from 'qs';
import axios from "axios";
import { CONTENT_TYPE } from '@/apis/constant';

export const getAccountInfo = () => {
    return axios.get("/opc/account/info");
}

// check email/check pass/create temp user
export const signUp = (params = {}) => axios.post("/opc/buy/signup", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

// gdpr countries users update agreements info
export const gdprCall = (params = {}) => axios.post("/opt_gdprcall", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const logout = () => axios.get('/logout');

export const checkCorporateDomain = (email) => {
  return axios.get(`/billing/personal_domain/block?emailAddress=${email}`);
};
